import React from 'react';
import styled, { StylesProps, cx } from '../../../../lib/styles';
import inputStatusStyles from './InputStatus_styles';
import Icon from '../../Icon';

export interface InputStatusProps {
  className?: string;
  status: InputValidationStatus;
  message: string;
}

export type InputValidationStatus = 'good' | 'bad';

const InputStatus = ({
  className,
  status,
  message,
  styles,
}: InputStatusProps & StylesProps<typeof inputStatusStyles>) => {
  return (
    <div className={cx('InputStatus', styles.container, className)}>
      <Icon
        icon={status === 'good' ? 'check_circle' : 'error_outline'}
        className={styles.icon}
      />
      <div className={styles.message}>{message}</div>
    </div>
  );
};

export default styled(inputStatusStyles)(InputStatus);
